import { Alert, Collapse, Typography, Box, useTheme } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import { useState } from 'react';
import { ExpandableAlertProps } from 'src/components/ExpandableAlert/ExpandableAlert.types';

const ExpandableAlert = ({
  title,
  description,
  color = 'info',
  icon,
  sx,
}: ExpandableAlertProps) => {
  const [expanded, setExpanded] = useState(false);
  const theme = useTheme();

  const handleToggle = () => {
    setExpanded((prev) => !prev);
  };

  return (
    <Alert
      variant="filled"
      icon={
        icon ?? (
          <InfoOutlinedIcon
            sx={{ pt: { md: 0.3, sm: 0.2, xs: 0 } }}
            fontSize="small"
            htmlColor={theme.palette[color].contrastText}
          />
        )
      }
      onClick={handleToggle}
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        width: '100%',
        bgcolor: theme.palette[color].main,
        py: { md: 0.7, sm: 0.5, xs: 0.4 },
        cursor: 'pointer',
        ...sx,
      }}
    >
      <Box color={theme.palette[color].contrastText}>
        <Typography
          variant="body1"
          fontWeight="fontWeightMedium"
          color="inherit"
        >
          {title}
        </Typography>
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <Typography variant="body2" mt={0.5} component="div" color="inherit">
            {description}
          </Typography>
        </Collapse>
      </Box>
    </Alert>
  );
};

export default ExpandableAlert;
